import subpixel from '../util/canvasSubpixelOffset';
import Handle from './Handle';

/** Interactive handle that is a long skinny rectangle instead of a point. */
export default class EdgeHandle extends Handle {
	constructor(tool, params) {
		super(tool, params);

		this.state = {
			visible: true
		};

		this.params = {
			date: new Date(params.date),
			value: params.value,
			style: this.core.getStyle('tool.edgeHandle')
		};
	}

	/**
	 * x calc - go from date to idx to px
	 * y calc - go from value to px
	 */
	getCoords() {
		const { panel } = this.tool;
		const xDomain = panel.core.closestExchangeIndex(new Date(this.params.date));
		const xRange = panel.xAxis.primaryScale(xDomain);
		const xRangeRoundedUp = subpixel.px(xRange);
		const xPx = subpixel.px(
			xRange,
			// Only round up for subpixel offset if act won't cause index to go out of range
			xRangeRoundedUp <= panel.xAxis.primaryScale.range()[1]
		);
		const yPx = 0;

		return [xPx, yPx];
	}

	isWithin(mousePanel) {
		const coords = this.getCoords();
		const halfWidth = this.params.style.width / 2;

		if (!coords) return false;

		return (
			mousePanel[0] >= coords[0] - halfWidth &&
			mousePanel[0] < coords[0] + halfWidth
		);
	}

	render() {
		if (this.state.visible) {
			const coords = this.getCoords();
			if (!coords) return;

			const ctx = this.tool.panel.rootToolContext;
			const halfWidth = this.params.style.width / 2;

			if (this.renderCustom) {
				return this.renderCustom(ctx, coords, this.params);
			}

			ctx.save();
			ctx.beginPath();

			ctx.rect(
				coords[0] - halfWidth,
				2,
				this.params.style.width,
				this.tool.panel.size.height - 3
			);

			if (this.tool.state.selected) {
				ctx.strokeStyle = this.params.style.color || 'transparent';
				ctx.fillStyle = this.params.style.background.color || 'transparent';
				ctx.fill();
				ctx.stroke();
			} else if (this.tool.state.hover) {
				ctx.strokeStyle = this.params.style.hover.color || 'transparent';
				ctx.fillStyle = this.params.style.hover.background.color || 'transparent';
				ctx.fill();
				ctx.stroke();
			}
			ctx.restore();
		}
	}
}
